import { LessonSearchItem, LessonType } from "shared/lessons"
import { AssessmentResponse } from "shared/routes/assessments/assessments"
import { Type } from "shared/types/moduleTypes"

export function formatPureInquiry(module: string, tier: LessonType): LessonSearchItem {
    return {
        id: null,
        core: false,
        available: true,
        module: module,
        number: 0,
        title: "Pure Inquiry",
        thumbnail: `/simulations/${module.replace(/[.']/g, "").replace(/ /g, "-").toLowerCase()}/thumbnail.png`,
        type: tier,
        assessmentOnly: false,
        variety: "Pure Inquiry",
    }
}

export function formatGuidedLesson(lesson, availableLessons, showCore, coreMap): LessonSearchItem {
    return {
        core: showCore && coreMap.has(lesson.id) ? coreMap.get(lesson.id) : false,
        module: lesson.module,
        number: lesson.number,
        available: availableLessons ? availableLessons.some(al => al === lesson.id) : true,
        title: lesson.title,
        thumbnail: `/simulations/${lesson.module.replace(/[.']/g, "").replace(/ /g, "-").toLowerCase()}/thumbnail.png`,
        id: lesson.id,
        type: lesson.type,
        variety: "Guided",
        assessmentOnly: false,
        assessment: lesson.assessment
    }
}

export function formatAssessmentOnly(assessment: AssessmentResponse): LessonSearchItem {
    if (!assessment) return null
    return {
        core: false,
        module: assessment.module,
        number: assessment.number,
        available: true,
        title: assessment.title,
        thumbnail: `/simulations/${assessment.module.replace(/[.']/g, "").replace(/ /g, "-").toLowerCase()}/thumbnail.png`,
        id: assessment.id,
        type: assessment.type as Type,
        variety: "Guided",
        assessmentOnly: true,
        assessment: assessment
    }
}
